const MODAL = 'MODAL';
export const MODAL_DISPLAY = `${MODAL}_DISPLAY`;
export const MODAL_DISMISS = `${MODAL}_DISMISS`;
